import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';
import {PostData} from '../../services/PostData';
import {GetData} from '../../services/GetData';
import {
  Row,
  Col,
  Button,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Card,
  CardHeader,
  CardFooter,
  CardBody,
  Collapse,
  Form,
  FormGroup,
  FormText,
  Label,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Table
} from 'reactstrap';

class Driver extends Component {
	
	/** set property value **/
	constructor(props){
		super(props);
		this.state = {
			vno : '',
			dname : '',
			preaddr : '',
			peraddr : '',
			dob : '',
			mob : '',
			licno : '',
			_message : '',
			alertClass :'',
			vehi : [],
			id : '',
		  _redirect : false,
		  posts: []
		}
		this.onChange = this.onChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.handleClick = this.handleClick.bind(this);
		this.onUpdate = this.onUpdate.bind(this);
		this.onClick = this.onClick.bind(this);
	}
	
	onClick(e){
		
		document.getElementById("driform").reset();
	}
	
	/** set value **/
	onChange(e){
		this.setState({[e.target.name]:e.target.value});
		console.log(this.state);
	}
	
	/** set value to react select **/
	handleChange(value){
		
		this.setState({value});
		console.log(this.state.value);
		
	}
	
	onSubmit(e){
		e.preventDefault();
		
		if(this.state.vno && this.state.dname && this.state.peraddr && this.state.dob && this.state.mob && this.state.licno){
			
			PostData('transport/adddriver',this.state).then((result) => {
				let responseJson = result;
				if(responseJson.status == '1' ){
					this.setState({
						_message:'Driver Added Successfully!..',
						alertClass:'alert alert-success',
					});
					document.getElementById("driform").reset();
					this.getdata();
				}
				else{
			
					this.setState({
						_message:'Invalid Key',
						alertClass:'alert alert-danger'
					});
				}
			});
		
		}
	
	}
	
	handleClick(dd){
		
		this.state.id = dd;
		console.log('id'+this.state.id);
		
		if (window.confirm("Do you want to Delete?")) { 		
			PostData('transport/deletedri',this.state).then((result) => {
				let responseJson = result;
				console.log(responseJson);
				if(responseJson.status == '1'){
					this.setState({
						_message:'Driver Removed Successfullly',
						alertClass:'alert alert-success'
					});
					this.getdata();
				}
				else{
			
					this.setState({
						_message:'Error in Remove Driver',
						alertClass:'alert alert-danger'
					});
				}
			});
		}
	}
	
	onUpdate(dt){
		
		this.state.idd = dt;
		this.setState({_redirect: true});
		
	}
	
	/** this function will be call when page loading **/
	componentWillMount(){
		
		this.getdata();
		this.getvehicleno();
	}
	
	getdata(){
		
		GetData('transport/getdriver').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					posts : responseJson
				});
			}
		});
	}
	
	/** get Vehicle **/
	getvehicleno(){
	  
		GetData('transport/getvehicle').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					vehi : responseJson
				});
			}
		});
	  
	}
	
  render() {
	  
	if(this.state._redirect){
		  
		return (<Redirect to={'/transport/editdriver/' + this.state.idd} />);

	}
	
	var veh = this.state.vehi;
	
    return (
		<div className="animated fadeIn">
			<div className={this.state.alertClass}>
				{this.state._message}
			</div>
			<Row>
			  <Col md="5">
				<Card>
				  <form action="" method="post" role="form" id="driform" encType="multipart/form-data" onSubmit={this.onSubmit} >
					<CardHeader>
						<strong>Add Driver</strong>
					</CardHeader>
					<CardBody>
						<Row>
						  <Col md="12">
							<FormGroup>
							  <Label htmlFor="name">Vehicle No <span className="text-danger">*</span></Label>
							  <select name="vno" onChange={this.onChange} className="form-control" required>
								<option value="">Select</option>
								{
									veh.map(function (item) {
										return <option value={item.id }>{item.vehicleno}</option>;
									})
								}
							  </select>
							</FormGroup>
						  </Col>
						  <Col md="12">
							<FormGroup>
							  <Label htmlFor="name">Name <span className="text-danger">*</span></Label>
							  <Input type="text" name="dname" required onChange={this.onChange} />
							</FormGroup>
						  </Col>
						  <Col md="12">
							<FormGroup>
							  <Label htmlFor="name">Present Address <span className="text-danger">*</span></Label>
							  <Input type="textarea" name="preaddr" required onChange={this.onChange} />
							</FormGroup>
						  </Col>
						  <Col md="12">
							<FormGroup>
							  <Label htmlFor="name">Permanent Address <span className="text-danger">*</span></Label>
							  <Input type="textarea" name="peraddr" required onChange={this.onChange} />
							</FormGroup>
						  </Col>
						  <Col md="12">
							<FormGroup>
							  <Label htmlFor="name">Date of Birth <span className="text-danger">*</span></Label>
							  <Input type="date" name="dob" required onChange={this.onChange} />
							</FormGroup>
						  </Col>
						  <Col md="12">
							<FormGroup>
							  <Label htmlFor="name">Mobile <span className="text-danger">*</span></Label>
							  <Input type="text" name="mob" required onChange={this.onChange} />
							</FormGroup>
						  </Col>
						  <Col md="12">
							<FormGroup>
							  <Label htmlFor="name">License No <span className="text-danger">*</span></Label>
							  <Input type="text" name="licno" required onChange={this.onChange} />
							</FormGroup>
						  </Col>
						</Row>
					</CardBody>
					<CardFooter>
						<Button type="submit" size="sm" color="primary"><i className="fa fa-dot-circle-o"></i> Submit</Button>
						<Button type="reset" size="sm" color="danger" onClick={this.onClick}><i className="fa fa-ban"></i> Reset</Button>
					</CardFooter>
				  </form>
				</Card>
			  </Col>
			  <Col md="7">
			   <Card>
				<CardBody>
				<Table responsive bordered>
					<thead>
						<tr>
							<th>S.No</th>
							<th>Vehicle No</th>
							<th>Name</th>
							<th>License No</th>
							<th width="100">Manage</th>
						</tr>
					</thead>
					<tbody>
						{this.state.posts.map(item =>
						 
							<tr key = {item}>
								<td>{item.id}</td>
								<td>{item.vno}</td>
								<td>{item.name}</td>
								<td>{item.licenseno}</td>
								<td>
									<button name="editsub" className="btn btn-info btn-sm" onClick={() => this.onUpdate(item.id)} ><i className="fa fa-edit"></i></button>
									&nbsp;&nbsp;
									<button name="removesub" className="btn btn-danger btn-sm" onClick={() => this.handleClick(item.id)} ><i className="fa fa-remove"></i></button>
								</td>
							</tr>

						 )}
					</tbody>
				</Table>
				</CardBody>
			   </Card>
			  </Col>
			</Row>
		</div>
	)
  }
}

export default Driver;


// WEBPACK FOOTER //
// ./src/transport/Driver/Driver.js